export default {"src":"/_next/static/media/legalDoc_24.4b1705d7.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};